import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-arrow-down-right",
  templateUrl: "./med-icon-arrow-down-right.component.html",
})
export class MedIconArrowDownRightComponent extends SvgMixinComponent {}
